<template>
  <div>
    <div class="mobile">
      <span v-if="arr[eye]">{{ arr.holder[keyName+1] }}</span>
      <span v-else>{{ arr.holder[keyName] }}</span>
      <span v-if="arr.holder[keyName]">
        <i class="iconfont iconxianshi eye-icon eye" v-if="arr[eye]" @click="openEye(arr)"></i>
        <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(arr)"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
export default {
  mixins: [common],
  props: ["arr","eye","keyName"],
  data() {
    return {

    }
  },
  methods: {
    openEye(arr) {
      let operationType
      if(this.keyName == 'cardNumber'){
        operationType = 1
      }else if(this.keyName == 'mobile'){
        operationType = 2
      }else if(this.keyName == 'email'){
        operationType = 4
      }else if(this.keyName == 'address'){
        operationType = 5
      }
      if (!arr[this.eye]) {
        this.descrypt(
          {
            query: arr.orderNo,
            operationFunction: 14,
            operationType: operationType,
            otherInfo:{
              type:1
            }
          },
          arr.holder,
          this.keyName+'1',
          'order_10_6'
        ).then(() => {
          this.$set(arr, this.eye, true);
        });
      } else {
        this.$set(arr, this.eye, false);
      }
    },
  }
}
</script>

<style></style>